import { PortalRoute, QueryParamsHandlingStrategy } from '../../types/portal-route';
import { RouterStateUrl } from '../../types/router-state-url';
import { NavigationRequest } from '../../types/navigation-request';
import { getRoutingRequest } from '@rootTypes/utils/router/get-routing-request';
import { Injectable } from '@angular/core';
import { PortalRouterService } from '../../types/portal-router-service';
import { RouterOutlets } from '@rootTypes/entities/router';

export type AddVendorEmployeeProfileRouteData = {
  forVendorId?: string;
};

export const vendorEmployeeAddProfileRoute: PortalRoute<AddVendorEmployeeProfileRouteData> = {
  path: '',
  isOnRoute: (state: RouterStateUrl): boolean => {
    throw new Error('Not implemented');
  },
  parse: (state: RouterStateUrl): AddVendorEmployeeProfileRouteData => {
    let data: AddVendorEmployeeProfileRouteData = {};
    if (state.queryParams) {
      data = {
        ...data,
        ...state.queryParams,
      };
    }
    return data;
  },
  request: (
    data: AddVendorEmployeeProfileRouteData,
    queryParamStrategy?: QueryParamsHandlingStrategy,
    replaceUrl?,
  ): NavigationRequest => {
    const path = ['_', 'drawer', 'vendor-employees', 'add', 'profile'];
    const routeData = { ...data };
    return getRoutingRequest(path, routeData, queryParamStrategy, replaceUrl);
  },
};

@Injectable({ providedIn: 'root' })
export class VendorEmployeeAddProfileRouterService extends PortalRouterService<AddVendorEmployeeProfileRouteData> {
  outlet = RouterOutlets.DRAWER;
  route: PortalRoute<AddVendorEmployeeProfileRouteData> = vendorEmployeeAddProfileRoute;
}
